export default __webpack_public_path__ + "media/images/dashboard_icons/chair-1178941fc985bf85f27c1649232499e8.svg";